import { render } from "./PriceSelection.vue?vue&type=template&id=7ff7369b"
import script from "./PriceSelection.vue?vue&type=script&lang=js"
export * from "./PriceSelection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__